if (!customElements.get('image-banner-slider')) {
  class ImageBannerSlider extends HTMLElement {
    connectedCallback() {
      this.swiperElement = this.querySelector('.swiper');

      if (!this.swiperElement) return;

      const slides = this.querySelectorAll('.swiper-slide');
      this.mobileMediaQuery = window.matchMedia('(max-width: 749px)');
      this.handleMediaChange = () => this.updateArrowColor();

      this.slider = new Swiper(this.swiperElement, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: slides.length > 1,
        navigation: {
          prevEl: this.querySelector('.swiper-arrow--prev'),
          nextEl: this.querySelector('.swiper-arrow--next'),
        },
      });

      this.updateArrowColor();
      this.slider.on('slideChange', () => this.updateArrowColor());
      this.mobileMediaQuery.addEventListener('change', this.handleMediaChange);
    }

    disconnectedCallback() {
      this.mobileMediaQuery?.removeEventListener('change', this.handleMediaChange);
    }

    updateArrowColor() {
      const activeSlide = this.slider?.slides?.[this.slider.activeIndex];
      const slide = activeSlide?.querySelector('.image-banner__slide');

      if (!slide) return;

      const styles = window.getComputedStyle(slide);
      const colorVariable = this.mobileMediaQuery.matches
        ? '--image-banner-text-color-mobile'
        : '--image-banner-text-color';
      const color = styles.getPropertyValue(colorVariable).trim();

      if (color) {
        this.style.setProperty('--image-banner-arrow-color', color);
      }
    }
  }

  customElements.define('image-banner-slider', ImageBannerSlider);
}
